import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Q as QUANTITY_REQUIRED_MESSAGE } from '../../../../../../../validation-g1IuPS7K.js';

const getInitialValues = (quantity) => ({
    quantity: String(quantity),
});

const validationSchema = object().shape({
    quantity: string().required(QUANTITY_REQUIRED_MESSAGE),
});
var validationSchema$1 = yupResolver(validationSchema);

export { getInitialValues, validationSchema$1 as validationSchema };
//# sourceMappingURL=index.js.map
